export default __webpack_public_path__ + "static/recorlev-medication-guide-a7f1c17c054510863394a777ba5e0bc9.pdf";